<script>
import PopupAlert from '@/components/Popup/PopupAlert.vue'
import NavBar from '@/components/NavBar.vue'
import LayoutWithNav from '@/layouts/LayoutWithNav.vue'
// import PointNewCouponItem from '@/components/PointNewCouponItem.vue'
import { queryAllRewardCoupon, KgQueryMemberBonus, GetCollectionCardInfo } from '@/apis/api.js'
export default {
  name: 'PointCouponIndex',
  components: {
    NavBar,
    LayoutWithNav,
    // PointNewCouponItem,
    PopupAlert
  },
  data: () => ({
    content: '',
    card_point: 0,
    over_point: 0,
    currentType: 0,
    redeemType: [
      {
        name: '全部',
        value: 'all',
      },
      {
        name: '點數兌換',
        value: 'exchange',
      },
      {
        name: '加價兌換',
        value: 'add',
      },
    ],
    tabList: [
      {
        name: '可兌換',
        value: 'unget',
      },
      {
        name: '其他優惠券',
        value: 'other',
      },
    ],
    currentTab: 'unget',
    couponUngetList: [],
    couponUndoneList: [],
    couponDoneList: [],
    showRedeem: false,
    url: '',
  }),
  beforeCreate() {
    this.$store.state.isLoading = true
  },
  created() {
    var parent = this
    if (
      !localStorage.getItem('phone') ||
      !localStorage.getItem('password') ||
      !localStorage.getItem('member_no')
    ) {
      this.$router.push('/login')
    } else {
      this.getAllRewardCoupon().then(function () {})
      KgQueryMemberBonus(localStorage.getItem('phone'), localStorage.getItem('member_no')).then(
        function (rsp) {
          parent.card_point = rsp.MEB_Bonus
          parent.over_point = rsp.MEB_BonusLastYear
        }
      )
      GetCollectionCardInfo().then(function (rsp) {        
        parent.content = rsp.data[0]
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$store.state.isLoading = false
    })
  },
  methods: {
    handleConfirm() {
      this.showRedeem = false
    },
    handleClick() {
      this.showRedeem = true
    },
    tabHandler(value) {
      this.currentTab = value
    },
    getAllRewardCoupon() {
      const parent = this
      return new Promise(function (resolve) {
        queryAllRewardCoupon(localStorage.getItem('phone'), localStorage.getItem('password')).then(
          function (rsp) {
            // rsp = JSON.parse(rsp);
            console.log(rsp);
            
            parent.couponUndoneList = []
            parent.couponUngetList = []
            for (let i in rsp) {
              console.log(rsp[i].point, parent.$route.query.point)
              if (parseInt(rsp[i].point) > parseInt(parent.$route.query.point)) {
                parent.couponUndoneList.push(rsp[i])
              } else {
                parent.couponUngetList.push(rsp[i])
              }
            }

            resolve()
          }
        )
      })
    },
  },
}
</script>

<template>
  <LayoutWithNav>
    <PopupAlert v-model="showRedeem" type="redeem" />
    <img
      src="@/assets/images/newbg_t.png"
      style="position: absolute; top: 0px; left: 0; width: 100%; aspect-ratio: 375/812"
      alt=""
    />
    <NavBar color="#FF9F4B" title="會員點數">
      <!-- <template #right_icon>
        <div style="font-size: 14px; font-weight: 700; line-height: 16.8px; color: #fff">
          集點辦法
        </div>
      </template> -->
    </NavBar>
    <div class="info_wrappper">
      <div class="id_card">
        <div class="infos">
          <div class="point">
            <div class="name">
              <img style="width: 28px" src="@/assets/images/ppp.svg" alt="" />
              <p>我的點數</p>
            </div>
            <p class="pb">
              {{ card_point.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}<span>點</span>
            </p>
          </div>
          <!-- <div style="width: 100%; height: 1px; background-color: #d9d9d9"></div>
          <div class="over_point">
            2025/03/31到期點數:
            <span>{{ over_point.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}</span>
          </div> -->
        </div>
      </div>
      <div style="padding: 0px 32px; text-align: start;" v-html="content"></div>
      <!-- <div class="type">
        <div
          :class="{ active: currentType === index }"
          v-for="(type, index) in redeemType"
          :key="type.value"
          @click="currentType = index"
        >
          {{ type.name }}
        </div>
      </div> -->
      <!-- <div class="unget_list list">
        <div class="result">共{{ couponUngetList.length }}個結果</div>
        <div class="line-text">
          <span>可兌換({{ couponUngetList.length }})</span>
        </div>
        <p v-if="!couponUngetList.length">
          感謝您的支持，目前點數尚不足兌換優惠券，請您繼續累積點數。
        </p>
        <PointNewCouponItem
          v-for="(el, idx) in couponUngetList"
          :key="idx"
          :data="el"
          status="unget"
          @click:exchange="handleClick"
        ></PointNewCouponItem>
      </div> -->
      <!-- <div class="undone_list list">
        <div class="line-text">
          <span>不可兌換({{ couponUndoneList.length }})</span>
        </div>
        <PointNewCouponItem
          v-for="(el, idx) in couponUndoneList"
          :key="idx"
          :data="el"
          status="other"
          :valid="el.valid"
        ></PointNewCouponItem>
      </div> -->
    </div>
  </LayoutWithNav>
</template>

<style lang="scss" scoped>
h2 {
  color: $color_main_first;
  font-size: 26px;
  font-weight: bold;
  padding: 12px 16px;
  line-height: 1;
  text-align: left;
}
.list {
  padding: 0 32px 0px;
  & .result {
    font-size: 12px;
    line-height: 14.4px;
    color: #909090;
    text-align: left;
    margin-bottom: 12px;
  }
}
.line-text {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%; /* 可根據需求調整寬度 */
  color: #909090; /* 文字顏色 */
  font-size: 12px; /* 文字大小 */
  line-height: 14.4px;
  margin-bottom: 12px;
}

.line-text::before,
.line-text::after {
  content: '';
  flex: 1;
  height: 1px;
  background-color: #ccc; /* 線條顏色 */
}
.line-text::before {
  margin-right: 12px;
}
.line-text::after {
  margin-left: 12px;
}
.info_wrappper {
  font-family: Noto Sans TC;
  position: relative;
  .type {
    display: flex;
    padding: 0 32px;
    gap: 8px;
    & div {
      margin-bottom: 16px;
      font-size: 11px;
      line-height: 13.2px;
      letter-spacing: 0.44px;
      padding: 9.5px 12px;
      background-color: #fff;
      color: #ff7649;
      border: solid 1px #ff7649;
      border-radius: 8px;
      &.active {
        background-color: #ff7649 !important;
        color: #fff !important;
      }
    }
  }
  .id_card {
    padding: 16px 37.5px;
    font-family: Noto Sans TC;
    & .infos {
      padding: 16px;
      background: #fff7eb;
      border-radius: 14px;
      border: solid 2px #ffdaad;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 100%;
      height: 100%;
      gap: 8px;
      & .point {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px 0;
        & .name {
          display: flex;
          align-items: center;
          gap: 4px;
          font-weight: 400;
          color: #4b2518;
          font-size: 14px;
          line-height: 12px;
        }
        & .pb {
          font-size: 24px;
          line-height: 24px;
          font-weight: 500;
          color: #4b2518;
          & span {
            font-weight: 400;
            font-size: 14px;
            line-height: 14.4px;
            margin-left: 4px;
          }
        }
      }
      & .over_point {
        text-align: left;
        font-size: 12px;
        line-height: 14.4px;
        letter-spacing: 4%;
        padding: 5.5px 0px;
        color: #6f6f6f;
        white-space: nowrap;
        & span {
          font-weight: 500;
          color: #ff9f4b;
        }
      }
    }
  }
}
</style>
